import Vue from "vue";
import Router from "vue-router";
import store from "@/stores/store";

// Import components
// const Home = () => import("@/views/Home.vue");
const Home = () => import("@/views/Landing.vue");

const Dashboard = () => import("@/views/Dashboard.vue");

const Login = () => import("@/views/Login.vue");
const Logout = () => import("@/views/Logout.vue");

import { Roles } from "@/_helpers/Role";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { authorize: [] }
    },

    {
      path: "/dashboard",
      component: Dashboard,
      meta: { authorize: Roles.CompanyOrUser }
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout
    }
  ],

  duplicateNavigationPolicy: 'reload'
});

router.beforeEach((to, from, next) => {
  if (to.meta.authorize && to.meta.authorize.length > 0) {
    var role = store.state.users.currentUser.role;

    if (!role) next({ path: "/login" });

    if (to.meta.authorize.includes(role)) {
      next();
    } else {
      next({ path: "/" });
    }
  }

  next();
});

export default router;
